// An activity as a phone row: its type, the title (a diamond when it is a milestone), when and where it sits, and its
// state as a tag. Used by Space and Track.
import type { Activity, ActivityStatus } from '@dpw/shared';
import { STATUS_LABELS } from '@dpw/shared';
import { TypeIcon } from '../ui/icons';
import { dayLabel, localDay, localTime } from '../lib/format';
import { Row, Tag } from './kit';
import { useNewSince } from '../lib/seen';
import { NewDot } from '../ui/NewDot';

const TONE: Record<ActivityStatus, '' | 'g' | 'a' | 'r'> = { not_started: '', in_progress: 'a', at_risk: 'r', blocked: 'r', done: 'g' };
const IC = { meeting: 'blu', workshop: 'blu', deliverable: '', task: '' } as const;

export function whenLine(a: Pick<Activity, 'startsAt' | 'dueDate' | 'dueTime'>) {
  if (a.startsAt) return `${dayLabel(localDay(a.startsAt))} · ${localTime(a.startsAt)}`;
  if (a.dueDate) return `Due ${dayLabel(a.dueDate)}${a.dueTime ? ` ${a.dueTime}` : ''}`;
  return 'No date';
}

export function ActivityRow({ a, sub }: { a: Activity; sub: string }) {
  // The blue "new" dot after the title (6.3), as on the desktop's rows.
  const dots = useNewSince();
  return (
    <Row activity={a.id} icon={<TypeIcon type={a.type} />} iconTone={IC[a.type]} chevron={false}
      title={<>{a.isMilestone && <span className="ph-dia" aria-label="Milestone" />}{a.title}{dots.row(a.id) && <NewDot />}</>}
      sub={`${whenLine(a)} · ${sub}`}
      right={a.isOverdue ? <Tag tone="r">Overdue</Tag> : <Tag tone={TONE[a.status]}>{STATUS_LABELS[a.status]}</Tag>} />
  );
}
